<template>
<section id="contacto" class="contacto" data-aos="zoom-in-up">
    <div class="container">
        <div class="section-title">
            <h2>Contacto</h2>
        </div>
        <div class="row mt-1">
            <div class="col-lg-2">
            </div>
            <div class="col-lg-8 mt-5 mt-lg-0">
                <form @submit.prevent="sendMail" role="form" class="email-form">
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control" v-model="email.from_name" name="from_name" placeholder="Nombre*" required>
                        </div>
                        <div class="col-md-6 form-group mt-3 mt-md-0">
                            <input type="email" class="form-control" v-model="email.email" name="email" placeholder="Correo*" required>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <textarea class="form-control" rows="5" v-model="email.message" name="message" placeholder="Ingresa tu mensaje*" required></textarea>
                    </div>
                    <div class="my-3 text-center text-primary">
                        <div v-show="email.isloading" class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="text-center" v-show="!email.isloading"><button type="submit">Enviar</button></div>
                </form>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import emailjs from 'emailjs-com';
import
{
    emailConfig
}
from '@/Utils/data';
export default
{
    name: "main-contact",
    data()
    {
        return {
            service_id: "",
            template: "",
            user_id: "",
            email:
            {
                name: "",
                email: "",
                message: "",
                from_name: "",
                isloading: false,
            },
        }
    },

    methods:
    {
        /**
         * Enviar correo con los datos ingresados
         */
        async sendMail(e)
        {
            try
            {
                this.email.isloading = true;
                const res = await emailjs.sendForm('service_ldr69ux', 'template_76dz556', e.target, 'a0nV0fzxBBzh4Cli1');

                if (res.status == 200)
                {
                    alertify.success('Su mensaje ha sido enviado')
                    this.email = {
                        name: "",
                        email: "",
                        message: "",
                        from_name: "",
                        isloading: false
                    }
                }
                else
                {
                    alertify.error('Oops! Intente más tarde')
                    console.error(res);
                }
                this.email.isloading = false;
            }
            catch (ex)
            {
                alertify.error('Oops! Intente más tarde')
                this.email.isloading = false;
                console.error(ex);
            }
        }
    },

    mounted()
    {
        const mail_config = emailConfig();
        this.service_id = mail_config.service_id;
        this.template = mail_config.template;
        this.user_id = mail_config.user_id;
    }
}
</script>

<style>

</style>
